<template>
	<div>
		<div class="row">
			<div class="col">
				<h1>
					Edit a company value
				</h1>
			</div>

			<div class="col-auto">
				<locale-switcher @change="fetchAgain" />
			</div>
		</div>

		<form class="mt-4" @submit.prevent="saveCompanyValue">
			<div class="form-group">
				<label for="content">
					<small class="text-muted">CONTENT</small>
				</label>
				<textarea class="form-control" name="content" placeholder="Value Content" v-model="content" required autofocus />
			</div>

			<div class="form-group">
				<label for="content">
					<small class="text-muted">IMAGE</small>
				</label>
				<file-input @change="setImage" placeholder="Choose image (replace old if set)" multiple />
			</div>

			<button type="submit" class="btn btn-primary ld-ext-right mt-3" :disabled="loading" :class="{running: loading}">
				{{ loading ? 'Saving…' : 'Save' }}
				<div class="ld ld-ring ld-spin" />
			</button>
		</form>

		<div class="alert alert-danger mt-4" v-if="!loading && error">
			<p class="mb-0 text-center">
				{{ error }}
			</p>
		</div>
	</div>
</template>


<script>
	import store from '../../../store';
	import FileInput from '../../FileInput';
	import {getError} from '../../../helpers';
	import {mapState, mapGetters} from 'vuex';
	import LocaleSwitcher from '../../LocaleSwitcher';

	export default {
		components: {
			'file-input': FileInput,
			'locale-switcher': LocaleSwitcher,
        },

        data() {
			return {
				image: null,
				content: '',
                
                loading: false,
				error: '',
			};
        },
        
        methods: {
			saveCompanyValue() {
				this.loading = true;

				this.$store.dispatch('companyValues/update', {
					id: this.companyValue.id,
					content: this.content,
					image: this.image,
				}).then(restaurant => {
					this.$router.push({name: 'settings'});
				}).catch(e => {
					this.error = getError(e);
					this.loading = false;
				});
			},
			
			fetchAgain({oldValue}) {
				this.loading = true;

				this.$store.dispatch('companyValues/update', {
					id: this.companyValue.id,
					content: this.content,
				}).then(async () => {
					const value = await this.$store.dispatch('companyValues/fetch', {id: this.$route.params.id});
					this.content = value.title;
				}).catch(e => {
					this.$store.dispatch('setContentLocale', oldValue);
					this.error = getError(e);
				}).finally(() => {
					this.loading = false;
				});
			},

            setImage(files) {
				this.image = files[0];
			}
		},

		computed: {
			...mapGetters({
				getValueById: 'companyValues/getById',
			}),

			companyValue() {
				return this.getValueById(parseInt(this.$route.params.id));
			},
		},
		
		async beforeRouteEnter(to, from, next) {
			return store.dispatch('companyValues/fetch', {id: to.params.id}).then(value => {
				next(vm => {
					vm.content = value.title;
				});
			});
		},

		meta: {
			title: 'Edit a company value',

			meta: [
				{property: 'og:title', content: 'Edit a company value / Al-Shayah'},
			],
		},
    }
</script>